import * as rest from '../../services'
import React, { useEffect, useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Link } from '@reach/router'
import { Loading } from '../../components'

export const RepairInventoryItemUseLog = ({ record }) => {
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState([])
  useEffect(() => {
    setLoading(true)
    new rest.RepairInventoryService(record.url)
      .getHistory()
      .then((response) => {
        setLoading(false)
        setHistory(response)
      })
  }, [])

  return (
    <>
      {loading && <Loading />}
      {!loading && history?.results?.length > 0 && (
        <>
          <table className="table table-borderless table-sm">
            <thead>
              <tr>
                <th>Ticket</th>
                 <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {history?.results?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <Link
                        className={'text-dark'}
                        to={`/dashboard/ticket/${item.reference_number}`}
                      >
                        {item.reference_number}
                      </Link>
                    </td>
                     <td>

                        {item.status}

                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </>
      )}

      {!loading && !history?.results?.length > 0 && (
        <ReactBootstrap.Alert variant={'warning'}>
          No History Found.
        </ReactBootstrap.Alert>
      )}
    </>
  )
}
